import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { paths } from '../../assets/consts';

@Injectable()
export class LoginLegacyGuard {
	constructor(private readonly router: Router) {}

	canActivate(): boolean | UrlTree {
		// It's a temporary solution to redirect legacy login routes to labs home.
		// It's necessary until all customers are migrated to the new authentication system OR midc will fix redirect from their side.
		return this.router.createUrlTree([paths.home]);
	}
}
